import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInsuranceContractsState, IList, TError } from 'entities/insurance-contscts/types/InsuranseContracts-interface';
import { fetchContractList, fetchExelDownload } from 'entities/insurance-contscts/actions/fetch-contracts-list';


const initialState: IInsuranceContractsState = {
    list: [],
    ContractCount: 0,
    isLoadingList: false,
    errorList: [],
    lastFetchTime: null,
    currentPage: 1,
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: ""
};

export const contractsList = createSlice({
    name: 'contractsList',
    initialState,
    reducers: {
        resetListData: (state) => {
            state.list = [];
            state.ContractCount = 0;
            state.isLoadingList = false;
            state.errorList = [];
            state.lastFetchTime = null;
            state.currentPage = 1;
        },
        setCurrentPageInsuranceContracts: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPage = action.payload.page;
        },
        resetFileData: (state) => {
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchContractList.pending, (state) => {
                state.isLoadingList = true;
            })
            .addCase(fetchContractList.fulfilled, (state, action: PayloadAction<{ list: IList[], contractCount: number, fetchTime: number }>) => {
                state.isLoadingList = false;
                state.list = action.payload.list;
                state.ContractCount = action.payload.contractCount;
                state.errorList = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.isDownload = state.isDownload;
                state.errorDownload = state.errorDownload;
                state.FileData = state.FileData;
                state.FileName = state.FileName;
            })
            .addCase(fetchContractList.rejected, (state, action) => {
                state.list = [];
                state.isLoadingList = false;
                state.errorList = action.payload as TError;
                state.currentPage = 1;
                state.isDownload = state.isDownload;
                state.errorDownload = state.errorDownload;
                state.FileData = state.FileData;
                state.FileName = state.FileName;
            })
            .addCase(fetchExelDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchExelDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownload = [];
            })
            .addCase(fetchExelDownload.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownload = false;
                state.errorDownload = action.payload as TError;
            });
    },
});

export const { resetListData, setCurrentPageInsuranceContracts, resetFileData } = contractsList.actions;
export const contractsListReducer = contractsList.reducer;